import { USER_DATA } from '@customTypes/userData.interface'
import { myVehicleRoute } from '@views/MyVehicle/route.const'
import { registerRoute } from '@views/Register/route.const'

export const getRedirectUrl = (user: USER_DATA | null | undefined, plate: string, country: string) => {
    if (!user) {
        return `${registerRoute()}?redirectUrl=${encodeURIComponent(
            `${myVehicleRoute()}?plate=${plate}&country=${country}`
        )}`
    }

    const { license_plates } = user

    // if plate in license_plates return null
    if (license_plates.some((lp) => lp.plate === plate)) return null

    return `${myVehicleRoute()}?plate=${plate}&country=${country}`
}
